import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {ExcSectionComponent, ExcSelectComponent, OverlayConfig, OverlayRef} from 'exc-controls';
import {DefaultSettingsService} from '../../default-settings-service.service';

@Component({
  selector: 'app-modal-audit-reopen',
  templateUrl: './modal-audit-reopen.component.html',
  styles: []
})
export class ModalAuditReopenComponent extends ExcTranslation implements AfterViewInit {
  @ViewChild(ExcSelectComponent) VCExtension!: ExcSelectComponent;

  data = {Comment: null, Extension: null};

  constructor(private overlayConfig: OverlayConfig, private overlayRef: OverlayRef, private excDss: DefaultSettingsService) {
    super();
  }

  ngAfterViewInit(): void {
    if (this.excDss.Defaults.SelfcheckExtension) {
      this.VCExtension.value = this.excDss.Defaults.SelfcheckExtension[0];
    }
  }
}
